import { FormikValuesChangePassword } from "./interfaceValues";

export const initialValuesFormikUpdatePassword: FormikValuesChangePassword = {
  newPass: "",
  confirmPass: "",
};

